import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import WeeklyNew from "./components/WeeklyNew";
import LatestEpisodes from "./components/LatestEpisodes";
import OngoingSeries from "./components/OngoingSeries";
import Catalog from "./components/Catalog";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import About from "./components/About";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <WeeklyNew />
        <LatestEpisodes />
        <OngoingSeries />
        <Catalog />
        <Ranking />
        <Faq />
        <About />
      </main>
      <SiteFooter />
    </div>
  );
}